import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, shallowRef } from 'vue';
import { WidgetInfo } from '@/components/business/crud/widgets/WidgetContainer';
import { windows } from '@/components/common/window/Windows';
import { HasManyFieldType } from '@/components/business/crud/interface/FieldType';
import HasMany from '@/components/business/crud/widgets/impl/component/HasMany.vue';


import { definedWidgetMeta } from '@/components/business/crud/widgets/widgetManager';

export const meta = definedWidgetMeta({
  size: { show: 'large' },
});


export default /*#__PURE__*/_defineComponent({
  __name: 'HasManyTable',
  props: {
    propName: {},
    widget: {},
    info: {},
    data: {}
  },
  setup(__props: any) {

const props = __props;

function open() {
  windows.open({
    content: {
      type: 'component',
      component: shallowRef(HasMany),
      props: computed(() => {
        return {
          ...props,
          info: {
            ...props.info,
            status: 'edit',
          }
        }
      }),
    },
    title: props.info.title + '详情',
    width: 1280,
    height: 800,
    padding: 20,
  });
}

return (_ctx: any,_cache: any) => {
  const _component_sc_btn = _resolveComponent("sc-btn")!

  return (_openBlock(), _createBlock(_component_sc_btn, {
    type: "link",
    handler: open,
    text: "详情"
  }))
}
}

})